import React from 'react';
import { DataGridHeaderBaseProps } from '../../DataGridHeader.types';
import { AllieColors } from '../../../../common/color.types';
import { parseTextResponse } from '../../../../common/utils';
import { AllieText, TextType } from '../../../Text';

export type DataGridTextHeaderProps = {
  type?: TextType;
  weight?: 300 | 400 | 500 | 600;
  color?: AllieColors;
  suffix?: React.ReactNode
};

export const DataGridTextHeader: React.FC<
  DataGridHeaderBaseProps<DataGridTextHeaderProps>
> = ({ title, headerProps: { type = 'table-header', weight = 600, color = 'white' } }) => {
  return (
    <AllieText type={type} color={color} style={{ FontWeight: weight }}>
      {parseTextResponse(title)}
    </AllieText>
  );
};
